import { AllowedComponentPlaceholderListProperties } from '@adobe/aem-react-editable-components/dist/components/allowedcomponents/AllowedComponentsPlaceholderList';
import { AllowedComponentPlaceHolderProperties } from '@adobe/aem-react-editable-components/dist/components/allowedcomponents/AllowedComponentsPlaceholder';

const ALLOWED_COMPONENT_PLACEHOLDER_CLASS_NAMES = 'aem-AllowedComponent--component cq-placeholder placeholder';
const ALLOWED_COMPONENT_TITLE_CLASS_NAMES = 'aem-AllowedComponent--title';
const ALLOWED_PLACEHOLDER_CLASS_NAMES = 'aem-AllowedComponent--list';
export const AllowedComponentPlaceholder = ({ path, emptyLabel }: AllowedComponentPlaceHolderProperties) => {
  return (
    <div data-cq-data-path={path} data-emptytext={emptyLabel} className={ALLOWED_COMPONENT_PLACEHOLDER_CLASS_NAMES} />
  );
};

export const CustomAllowedComponentPlaceholderList = ({
  components,
  placeholderProps,
  title,
  emptyLabel,
}: AllowedComponentPlaceholderListProperties) => {
  const listLabel = components && components.length > 0 ? title : emptyLabel;

  return (
    <div className={`${ALLOWED_PLACEHOLDER_CLASS_NAMES} ${placeholderProps.placeholderClassNames}`}>
      <div data-text={listLabel} className={ALLOWED_COMPONENT_TITLE_CLASS_NAMES} />
      {components.map(component => (
        <AllowedComponentPlaceholder key={component.path} path={component.path} emptyLabel={component.title} />
      ))}
    </div>
  );
};
